/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


  /**
   * @see https://www.w3schools.com/howto/howto_js_draggable.asp 
   */
  function _makeDraggable(el) {
    let x2 = 0, y2 = 0, x1 = 0, y1 = 0;
    el.addEventListener('mousedown', function(e) {
      // skip dragging on form elements
      if (['.select2-container', 'button', 'select', 'input', 'textarea'].some(i => e.target.closest(i))) {
        return;
      }
      e.preventDefault();
      x1 = e.clientX;
      y1 = e.clientY;
      document.addEventListener('mouseup', mouseUp);
      document.addEventListener('mousemove', mouseMove);
    });
    function mouseUp() {
      document.removeEventListener('mouseup', mouseUp);
      document.removeEventListener('mousemove', mouseMove);
    }
    function mouseMove(e) {
      e.preventDefault();
      x2 = x1 - e.clientX;
      y2 = y1 - e.clientY;
      x1 = e.clientX;
      y1 = e.clientY;
      if (el.style.marginLeft) { x2 -= parseInt(el.style.marginLeft); el.style.marginLeft = null; }
      if (el.style.marginTop)  { y2 -= parseInt(el.style.marginTop);  el.style.marginTop  = null; }
      el.style.top  = (el.offsetTop - y2)    + "px";
      el.style.left = (el.offsetLeft - x2) + "px";
    }
  }

  const __vue_script__ = {
    name: "usermessage",
    props: {
      id: {},
      type: {
        type:    String,
        default: "info" // info, warning, alert, tool
      },
      title: {
        type:    String,
        default: null,
      },
      subtitle: {
        type:    String,
        default: null,
      },
      size: {
        type:    String, // values [small, fullpage]
        default: "fullpage"
      },
      message: {
        type:    String,
        default: ''
      },
      textMessage: {
        type:    Boolean,
        default: false
      },
      autoclose: {
        type:    Boolean,
        default: false
      },
      duration: {
        type:    Number,
        default: 3000
      },
      closable: {
        type:    Boolean,
        default: true
      },
      //@since 3.11.0
      iconClass: {
        type: String,
        default: null
      }
    },
    data() {
      return {
        style: {
          top:        'position-area' in document.body.style ? 'anchor(--g3w-view-map top)' : null,
          left:       'position-area' in document.body.style ? 'anchor(--g3w-view-map left)' : null,
          width:      'small' === this.size ? '325px' : (g3wsdk.core.ApplicationState.viewport.map.sizes.width + 'px'),
          marginLeft: 'small' === this.size ? (document.body.classList.contains('sidebar-collapse') ? '5px' : '40px') : null,
        }
      }
    },
    computed: {
      showheader() {
        return 'loading'!== this.type ;
      }
    },
    methods: {
      closeUserMessage() {
        if (this.$el.popover) {
          this.$el.hidePopover();
        }
        this.$emit('close-usermessage')
      },
    },
    
    async mounted() {
      this.$el.showPopover();
      if ('tool' === this.type) {
        _makeDraggable(this.$el);
      }
      if (this.size === 'fullpage') {
        this.uw = this.$watch(
          ()    => g3wsdk.core.ApplicationState.viewport.map.sizes.width, 
          width => this.style.width = 'fullpage' === this.size ? `${width}px`: this.style.width
        );
      }
      this.observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if ("class" === mutation.attributeName) {
            this.style.marginLeft = 'small' === this.size ? (mutation.target.classList.contains('sidebar-collapse') ? '5px' : '40px') : null;
          }
        });
      });
      this.observer.observe(document.body, { attributes: true });
      if (this.autoclose) {
        await this.$nextTick();
        const timer = setTimeout(() => {
          this.closeUserMessage();
          clearTimeout(timer)
        }, this.duration)
      }
    },
    beforeDestroy() {
      if (this.uw) {
        this.uw();
        this.uw = null;
      }
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  }

/* template */
var __vue_render__ = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"usermessage-content",class:( _obj = {}, _obj['usermessage-' + _vm.type] = true, _obj ),style:(_vm.style),attrs:{"id":_vm.id,"popover":"manual"}},[(_vm.showheader)?_c('div',{staticClass:"usermessage-header-content"},[_c('i',{staticClass:"usermessage-header-icontype",class:_vm.$fa(_vm.iconClass || _vm.type)}),_vm._v(" "),_c('div',{staticClass:"usermessage-header-title"},[_vm._t("header",function(){return [(_vm.title)?_c('h4',{directives:[{name:"t",rawName:"v-t",value:(_vm.title),expression:"title"}]}):_c('h4',[_vm._v(" "+_vm._s(_vm.type.toUpperCase()))]),_vm._v(" "),(_vm.subtitle)?_c('h5',{directives:[{name:"t",rawName:"v-t",value:(_vm.subtitle),expression:"subtitle"}],staticClass:"usermessage-header-subtitle"}):_vm._e()]})],2),_vm._v(" "),_c('div',{staticClass:"usermessage-header-right"},[(_vm.closable)?_c('div',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left",value:('close'),expression:"'close'",arg:"left"}],on:{"click":_vm.closeUserMessage}},[_c('i',{staticClass:"usermessage-header-right-item",class:_vm.$fa('close')})]):_vm._e()])]):_vm._e(),_vm._v(" "),_vm._t("body",function(){return [(_vm.textMessage)?_c('div',{staticClass:"usermessage-message"},[_vm._v(_vm._s(_vm.message))]):_c('div',{directives:[{name:"t",rawName:"v-t",value:(_vm.message),expression:"message"}],staticClass:"usermessage-message"})]}),_vm._v(" "),_vm._t("footer")],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-4aefe642_0", { source: "#g3w-view-map{anchor-name:--g3w-view-map}", map: undefined, media: undefined })
,inject("data-v-4aefe642_1", { source: ".usermessage-content[data-v-4aefe642]{color:#fff;line-height:normal;padding:3px;min-width:250px;border:unset;inset:unset;margin:unset}.usermessage-success[data-v-4aefe642]{background-color:#62ac62}.usermessage-info[data-v-4aefe642]{background-color:#44a0bb}.usermessage-warning[data-v-4aefe642]{background-color:#f29e1d}.usermessage-alert[data-v-4aefe642]{background-color:#c34943}.usermessage-tool[data-v-4aefe642]{background-color:#fff;color:#222d32;cursor:move;border:thin solid #ccc}.usermessage-loading[data-v-4aefe642]{background-color:#fff;color:#222d32;font-weight:700}.usermessage-header-content[data-v-4aefe642]{display:flex;align-items:baseline;justify-content:space-between;width:100%;border-bottom:2px solid #eee}.usermessage-header-icontype[data-v-4aefe642]{padding:10px 0 0 5px;font-weight:700;font-size:1.3em}.usermessage-header-title[data-v-4aefe642],.usermessage-header-title h4[data-v-4aefe642]{font-weight:700;text-align:center}.usermessage-header-subtitle[data-v-4aefe642]{font-weight:700;margin:5px}.usermessage-header-right[data-v-4aefe642]{padding:5px}.usermessage-header-right-item[data-v-4aefe642]{font-weight:700!important;font-size:1.2em;cursor:pointer}.usermessage-message[data-v-4aefe642]{width:100%;padding:10px;max-height:100px;font-size:1.1em;align-self:flex-start;overflow-y:auto}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-4aefe642"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "UserMessage.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__